import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Search, HelpCircle, Grid3x3, ArrowRight } from "lucide-react";
import GamesPageShell from "../../components/games/GamesPageShell";
import { GAMES_CATALOGUE } from "../../content/games";
import { trackGameEvent } from "../../lib/gameEvents";

const ICONS = { "spot-the-issue": Search, "quick-quiz": HelpCircle, "word-finder": Grid3x3 };

export default function GamesHub() {
  useEffect(() => { trackGameEvent("games_hub_viewed"); }, []);

  return (
    <GamesPageShell
      title="Games"
      description="Quick, practical games about rental safety, bookings, and vehicle condition. No login required, no scores saved anywhere but this page."
      backTo="/academy"
      backLabel="Back to Academy"
    >
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5" data-testid="games-hub-grid">
        {GAMES_CATALOGUE.map((g) => {
          const Icon = ICONS[g.id] || Grid3x3;
          return (
            <Link
              key={g.id}
              to={g.path}
              data-testid={`games-hub-card-${g.id}`}
              onClick={() => trackGameEvent("game_opened", { game: g.id })}
              className="min-h-11 rounded-2xl border border-slate-200 bg-white p-5 hover:border-emerald-300 hover:shadow-sm transition-all flex flex-col"
            >
              <div className="w-10 h-10 rounded-xl bg-emerald-50 grid place-items-center">
                <Icon className="w-5 h-5 text-emerald-700" aria-hidden="true" />
              </div>
              <div className="font-display text-lg font-semibold mt-3">{g.title}</div>
              <div className="text-xs text-emerald-700 font-medium mt-0.5">{g.tagline}</div>
              <p className="text-sm text-slate-600 mt-2 flex-1">{g.description}</p>
              <div className="inline-flex items-center gap-1 text-sm font-medium text-[#1B4332] mt-4">
                Play <ArrowRight className="w-4 h-4" aria-hidden="true" />
              </div>
            </Link>
          );
        })}
      </div>
    </GamesPageShell>
  );
}
